import React from "react";
import {Form,Input,Radio,InputNumber} from 'antd';
import NHFormItem from "../../../common/NHFormItem";
import NHSelect from "../../../common/NHSelect";

/**
 * 信息发布编辑表单
 */
class EditFlModal extends React.Component {

    static defaultProps = {
    }

    constructor(props) {
        super(props);
        this.state = {
              fflData:[],
        }
    }

    render() {
        const {form,flData,zt0,zt1} = this.props;
        return (
           <div>
               <forms>
                   <NHFormItem id={'flbz'}  label={"分类标志"} form={form} pattern={{pattern:/^[a-zA-Z0-9_]{0,50}$/, message: "请输入：a-zA-Z0-9_ 范围的值,不能超过50字符！"}}
                               required={flData.FLBZ?false:true} initialValue={flData.FLBZ}>
                       {flData.FLBZ?<span>{flData.FLBZ}</span>:<Input style={{width:'100%'}}/>}
                   </NHFormItem>
                   <NHFormItem id={'flbt'}  label={"分类标题"} form={form} pattern={{max: 300, message: "分类标题不能超过300字符！"}}
                               required={true} initialValue={flData.FLBT}>
                       <Input  style={{width:'100%'}} />
                   </NHFormItem>
                   <NHFormItem id={'fflbz'} label={"所属父分类"} form={form} initialValue={flData.FFLBZ}>
                       <NHSelect  style={{width:'100%'}} sign={"zhxg_yxxt_xxfb_firstInfo"}/>
                   </NHFormItem>
                   <NHFormItem id={'sfnrwy'}  label={"内容是否唯一"} form={form} initialValue={flData.SFNRWY?flData.SFNRWY:'0'}>
                       <Radio.Group>
                           <Radio value={"1"}>是</Radio>
                           <Radio value={"0"}>否</Radio>
                       </Radio.Group>
                   </NHFormItem>
                   <NHFormItem id={'zt'}  label={"状态"} form={form} initialValue={flData.ZT?flData.ZT:'1'}>
                       <Radio.Group>
                           <Radio value={"1"}>{zt1}</Radio>
                           <Radio value={"0"}>{zt0}</Radio>
                       </Radio.Group>
                   </NHFormItem>
                   <NHFormItem id={'pxh'}  label={"排序号"} form={form} initialValue={flData.PXH?flData.PXH:1}>
                       <InputNumber  min={0} max={999999}/>
                   </NHFormItem>
               </forms>
           </div>
        );
    }
}

const edit = Form.create()(EditFlModal);

export default edit;


// WEBPACK FOOTER //
// ./components/fwwgl/xxfb/xxfbfl/EditFlModal.js